import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { AllUserRolesColumns } from '../../../datatablesource'
import { handleError } from '../../../utils/error';
import newRequest from '../../../utils/newRequest';
import Datatable from '../../datatable/Datatable'
import "./allRoles.scss"
import { useTranslation } from "react-i18next";

const AllRoles = () => {
  const { t, i18n } = useTranslation();
  const [error, setError] = useState(null);
  const [allRolesList, setAllRolesList] = useState([]);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const getAllRoles = async () => {
      try {
        const response = await newRequest.get("/GetAllUsersRoles")
        setAllRolesList(response.data ?? []);
        setIsAuthenticating(false);
      }
      catch (error) {
        setIsAuthenticating(false);
        setError(error);
        handleError(error)
      }
    };

    getAllRoles();
  }, []);
  return (
    <div
      style={
        {
          // width: "80%",
        }
      }
    >
      <Datatable
        columnsName={AllUserRolesColumns(t)}
        data={allRolesList}
        title={t("ALL ROLES")}
        uniqueId="allRolesId"
        secondaryColor="secondary"
        apiEndPoint="/PostUsersRoles"
        addNewNavigation="/admin/database-config/all-roles/add-new-role"
        loading={isAuthenticating}
        deleteBtnEndPoint="/DeleteUsersRolesById"
        checkboxSelectionOption={false}
      />
    </div>
  );
}

export default AllRoles